export class ValidationResult {
  IsValid: boolean;
  Message: string;
}
